
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Careers from "../pages/careers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/join-our-team",
    element: <Careers />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
